"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleSlides = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var GoogleSlides = function GoogleSlides() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    d: "M18.5 22H5.5C5.10218 22 4.72064 21.8495 4.43934 21.5816C4.15804 21.3137 4 20.9503 4 20.5714V3.42857C4 3.04969 4.15804 2.68633 4.43934 2.41842C4.72064 2.15051 5.10218 2 5.5 2H15L20 6.7619V20.5714C20 20.9503 19.842 21.3137 19.5607 21.5816C19.2794 21.8495 18.8978 22 18.5 22Z",
    fill: "#FFC107"
  }), react_1.default.createElement("path", {
    d: "M20 6.7619H15V2L20 6.7619Z",
    fill: "#FFECB3"
  }), react_1.default.createElement("path", {
    d: "M15 6.76196L20 11.5239V6.76196H15Z",
    fill: "#FFA000"
  }), react_1.default.createElement("path", {
    d: "M15 11.0476H9C8.449 11.0476 8 11.4752 8 12V17.7143C8 18.239 8.449 18.6667 9 18.6667H15C15.551 18.6667 16 18.239 16 17.7143V12C16 11.4752 15.551 11.0476 15 11.0476ZM15 12.9524V16.7619H9V12.9524H15Z",
    fill: "white"
  }));
};

exports.GoogleSlides = GoogleSlides;